module.exports = __webpack_public_path__ + "img/tab-device-lock.4fa3d39b.png";